export default __webpack_public_path__ + "static/media/fr.15e1e526.svg";